<template>
  <v-app-bar app class="stylish-navbar" dense>
    <!-- Logo -->
    <v-img
      :class="{'logo-desktop': $vuetify.display.mdAndUp, 'logo-mobile': !$vuetify.display.mdAndUp}"
      src="@/assets/Logo11.png"
      alt="Logo"
    ></v-img>

    <!-- Title -->
    <h2 v-if="$vuetify.display.mdAndUp" class="header-title" @click="navigate">
      Alumni Registration System
    </h2>
    <h4 v-else class="header-titlem" @click="navigate">
      Alumni Registration System
    </h4>

    <v-spacer></v-spacer>

    <!-- Hamburger Icon for Mobile -->
    <v-app-bar-nav-icon v-if="!$vuetify.display.mdAndUp" @click="toggleDrawer"></v-app-bar-nav-icon>

    <!-- Links for Desktop -->
    <div class="d-flex nav-links-container" v-if="$vuetify.display.mdAndUp">
      <router-link v-if="!isAuthenticated" to="/register" class="nav-link" exact-active-class="active-link">
        Register
      </router-link>
      <router-link v-if="!isAuthenticated" to="/login" class="nav-link" exact-active-class="active-link">
        Login
      </router-link>

      <a
        v-if="!isAuthenticated"
        href="https://kshs.academy"
        target="_blank"
        rel="noopener noreferrer"
        class="nav-link"
        exact-active-class="active-link"
      >
        KSHS Website
      </a>

      <router-link v-if="!isAuthenticated" to="/contact" class="nav-link" exact-active-class="active-link">
        Contact Us
      </router-link>

      <!-- Account Menu for Logged-In Users -->
      <v-menu v-if="isAuthenticated" transition="scale-transition" offset-y class="custom-menu" right>
        <template v-slot:activator="{ props }">
          <v-btn icon v-bind="props" class="custom-avatar-btn">
            <v-avatar size="70">
              <v-icon size="70" color="white">mdi-account</v-icon>
            </v-avatar>
          </v-btn>
        </template>
        <v-list class="custom-list">
          <v-list-item>
            <h3 class="menu-header">👋 Hello {{ user }}</h3>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item link @click="navigateToProfile" class="hoverable-item">
            <v-list-item-title>Profile</v-list-item-title>
          </v-list-item>
          <v-list-item link @click="logout" class="hoverable-item">
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </v-app-bar>

  <!-- Mobile Navigation Drawer -->
  <template v-if="!$vuetify.display.mdAndUp">
    <v-navigation-drawer v-model="drawer" app temporary dark class="stylish-drawer" v-if="drawer">
      <v-list dense >
        <v-list-item class="pa-4">
          <v-list-item-content>
            <h4 class="stylish-title text-h5 font-weight-bold">
              <router-link v-if="!isAuthenticated" to="/alumni" class="drawer-logo">
                KSHS Alumni Registration System
              </router-link>
            </h4>
          </v-list-item-content>
        </v-list-item>

        <router-link v-if="!isAuthenticated" to="/register" exact-active-class="active-link" class="nav-drawer-link">
          Register
        </router-link>
        <router-link v-if="!isAuthenticated" to="/login" exact-active-class="active-link" class="nav-drawer-link">
          Login
        </router-link>

        <router-link v-if="!isAuthenticated" to="/contact" exact-active-class="active-link" class="nav-drawer-link">
          Contact Us
        </router-link>

        <!-- Mobile Account Menu -->
        <v-list v-if="isAuthenticated">
          <v-list-item>
            <v-avatar size="40">
              <v-icon size="50" color="white">mdi-account</v-icon>
            </v-avatar>
            <v-list-item-title class="ml-3">{{ user?.name }}</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item link @click="navigateToProfile">
            <v-list-item-title>Profile</v-list-item-title>
          </v-list-item>
          <v-list-item link @click="logout">
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-list>
    </v-navigation-drawer>
  </template>
</template>

<script>
export default {
  data() {
    return {
      drawer: false,
      isAuthenticated: false, // Replace with actual auth logic
      user: '',
    };
  },
  created() {
    this.user = this.$store.getters.user;
    this.isAuthenticated = this.$store.getters.isAuthenticated;
  },
  computed: {
    user() {
      
      return this.$store.getters.user.personalInfo ? this.$store.getters.user.personalInfo.email : this.$store.getters.user.email;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
  },
  methods: {
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    navigateToProfile() {
      this.$router.push("/profile");
    },
    logout() {
      this.$store.dispatch("logout");
      this.$router.push("/kaa");
      this.user = null;
      this.isAuthenticated = false;
      localStorage.removeItem('user');
      localStorage.removeItem('token');
    },
    navigate() {
      this.$router.push(this.isAuthenticated ? '/alumni' : '/');
    },
  },
};
</script>

<style scoped>
/* Enhanced Navbar Styles */
.stylish-navbar {
  background: linear-gradient(135deg, #e96c61, #4c0303);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);
  padding: 1.5rem 3rem;
  position: fixed;
  width: 100%;
  height: 80px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  top: 0;
  z-index: 1000;
  transition: background-color 0.3s ease, transform 0.3s ease-in-out, padding 0.2s ease, top 0.3s ease;
}

.stylish-navbar:hover {
  background: linear-gradient(135deg, #1abc9c, #0b298a);
  transform: translateY(-5px);
  padding: 1.5rem 3.5rem;
}

/* Header Title Styles */
.header-title {
  font-family: 'Poppins', sans-serif;
  color: white;
  font-weight: 700;
  font-size: 2rem;
  cursor: pointer;
  transition: color 0.3s ease, transform 0.2s ease;
}

.header-title:hover {
  color: #0a5e04;
}

.header-titlem {
  font-family: 'Poppins', sans-serif;
  color: white;
  font-weight: 500;
  font-size: .6rem;
  cursor: pointer;
}

.header-titlem:hover {
  color: #0a5e04;
}

/* Logo Styles */
.logo-desktop {
  width: 250px;
  transition: width 0.3s ease, transform 0.3s ease;
}

.logo-mobile {
  width: auto;
}

.stylish-navbar:hover .logo-desktop {
  width: 180px;
  transform: rotate(1deg);
}

/* Link Styles */
.nav-links-container {
  display: flex;
  gap: 2rem;
  align-items: center;
}

.nav-link {
  font-family: 'Poppins', sans-serif;
  color: white;
  font-weight: 500;
  font-size: 1.3rem;
  text-decoration: none;
  position: relative;
  transition: color 0.3s ease, transform 0.2s ease;
}

.nav-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: #088b1e;
  transform: scaleX(0);
  transform-origin: bottom right;
  transition: transform 0.25s ease-out;
}

.nav-link:hover {
  color: #7f0808;
  transform: scale(1.05);
}

.nav-link:hover::after {
  transform: scaleX(1);
  transform-origin: bottom left;
}

/* Mobile Drawer Styles */
.stylish-drawer {
  background: linear-gradient(135deg, #1abc9c, #0b298a);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.3);
  border-radius: 20px 0 0 20px;
  transition: all 0.3s ease;
  width: 80%; /* Ensure the drawer is wide enough */
}

.stylish-drawer:hover {
  background: linear-gradient(135deg, #1abc9c, #0b298a);
  transform: scale(1.02);
}

.nav-drawer-link {
  font-family: 'Poppins', sans-serif;
  color: white;
  font-size: 1.2rem;
  font-weight: 500;
  padding: 0.7rem 1.5rem;
  display: block;
  text-decoration: none;
  border-radius: 10px;
  transition: color 0.3s ease, transform 0.2s ease, background 0.3s ease;
}

.nav-drawer-link:hover {
  color: #0a7c0e;
  transform: scale(1.05);
  background: rgba(243, 156, 18, 0.1);
  padding-left: 1.8rem;
}

/* Active Link Styles */
.active-link {
  color: #3498db !important;
  font-weight: 700;
  border-bottom: 3px solid #12caf3;
}

.active-drawer-link {
  color: #12b0f3 !important;
  font-weight: bold;
}

/* Hover Effects on Drawer Links */
.nav-drawer-link:hover {
  color: #12e0f3;
  border-left: 5px solid #12f3f39e;
  padding-left: 1.8rem;
}

/* Mobile Specific Styles */
@media (max-width: 600px) {
  .logo-desktop {
    width: 180px;
  }

  .logo-mobile {
    width: 160px;
  }

  .nav-links-container {
    gap: 1rem;
  }

  .header-title {
    font-size: 1.6rem;
  }

  .nav-link {
    font-size: 1rem;
  }

  /* Hide navbar when off */
  .navbar-off {
    top: -80px; /* Moves the navbar out of the view */
  }
}

.stylish-title {
  font-family: 'Roboto', sans-serif;
  font-size: 2.5rem;
  background: linear-gradient(to right, #2711cb, #5a0404);
  -webkit-background-clip: text;
  color: transparent;
  text-transform: uppercase;
  letter-spacing: 2px;
  animation: glow-animation 1.5s ease-in-out infinite;
  display: inline-block;
  margin: 20px 0;
}

/* Stylish Drawer */
.stylish-drawer {
  background-color: #1a1a1a !important;
  box-shadow: 4px 0 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease-in-out, opacity 0.3s ease;
}

/* Custom router-link styling */
.nav-drawer-link {
  display: block;
  padding: 16px;
  font-size: 18px;
  font-weight: 500;
  color: #ffffff;
  text-decoration: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: background-color 0.2s, color 0.2s;
  border-radius: 4px;
}

.nav-drawer-link:hover {
  background-color: #880606;
  color: white;
}

/* Active link styling */
.active-link {
  background-color: #980a0a !important;
  color: white !important;
  border-radius: 4px;
}

/* Logo link styling */
.drawer-logo {
  color: hsl(0, 94%, 40%);
  text-decoration: none;
  font-weight: 700;
  font-size: 22px;
  display: block;
  text-align: center;
  transition: color 0.3s ease;
}

.drawer-logo:hover {
  color: #ffffff;
}

/* Responsive drawer on mobile */
@media (max-width: 600px) {
  .stylish-drawer {
    width: 80% !important;
  }
}

.custom-menu {
  max-width: 400px !important;
}

.custom-list {
  width: 300px !important;
}

/* Overall menu styles */
.custom-menu {
  border-radius: 16px;
  box-shadow: 0px 4px 12px rgb(143, 1, 1);
  min-width: 250px;
}

/* Avatar button styles */
.custom-avatar-btn {
  transition: transform 0.3s ease;
}

.custom-avatar-btn:hover {
  transform: scale(1.1);
}

/* List styling */
.custom-list {
  padding: 8px;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
}

/* Menu header */
.menu-header {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  text-align: center;
  margin-bottom: 8px;
}

/* Hoverable list items */
.hoverable-item {
  transition: background-color 0.3s ease, transform 0.3s ease;
  border-radius: 8px;
}

.hoverable-item:hover {
  background-color: #a8161e;
  transform: scale(1.02);
}

/* Divider styles */
.v-divider {
  margin: 8px 0;
  background-color: #e0e0e0;
}

/* Custom scrollbar for menus with overflow */
.custom-list::-webkit-scrollbar {
  width: 8px;
}

.custom-list::-webkit-scrollbar-thumb {
  background-color: #cccccc;
  border-radius: 8px;
}

.custom-list::-webkit-scrollbar-thumb:hover {
  background-color: #b3b3b3;
}
</style>